const config = {
    apiKey: "AIzaSyBraaVhuqMTpIleYN0kOKY9xv_rdZKqc-A",
    authDomain: "cutikocl.firebaseapp.com",
    databaseURL: "https://cutikocl.firebaseio.com",
    projectId: "cutikocl",
    storageBucket: "",
    messagingSenderId: "937536480965"
};

export default config;



// WEBPACK FOOTER //
// ./src/fire-config.js